import React from 'react'
import { Breadcrumb } from 'antd'
import css from './css/payNav'
import { observer, inject } from 'mobx-react'
import { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

const PayNav = ({text}) => {
  return <css.PayNav>{text}</css.PayNav>
}

export default PayNav
